import { render, staticRenderFns } from "./SingleOffer.vue?vue&type=template&id=871c6836&scoped=true"
import script from "./SingleOffer.vue?vue&type=script&lang=js"
export * from "./SingleOffer.vue?vue&type=script&lang=js"
import style0 from "./SingleOffer.vue?vue&type=style&index=0&id=871c6836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871c6836",
  null
  
)

export default component.exports